export const autoCloseDelayForToastMsg = 3000;
export const toastMessageTypes = {
  INFO: "INFO",
  SUCCESS: "SUCCESS",
  WARN: "WARN",
  ERROR: "ERROR",
  DARK: "DARK"
};
